"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function WaterMark(el, options) {
    options = __assign({ fillStyle: 'rgba(213, 213, 213, 0.4)', font: '20px Vedana', width: 150, height: 150, text: 'Tencent' }, options);
    var canvas = document.createElement('canvas');
    canvas.width = options.width;
    canvas.height = options.height;
    var context = canvas.getContext('2d');
    context.rotate(-15 * Math.PI / 180);
    context.fillStyle = options.fillStyle;
    context.font = options.font;
    context.textAlign = 'left';
    context.textBaseline = 'Middle';
    context.fillText(options.text, canvas.width / 6, canvas.height / 2);
    var dataUrl = canvas.toDataURL('image/png');
    var canvasDiv = document.createElement('div');
    var style = canvasDiv.style;
    style.position = 'absolute';
    style.left = 0;
    style.top = 0;
    style.width = '100%';
    style.height = '100%';
    style.background = 'url(' + dataUrl + ')';
    style.zIndex = 999;
    style.pointerEvents = 'none';
    el.style.position = 'relative';
    el.appendChild(canvasDiv);
}
exports.default = WaterMark;
//# sourceMappingURL=WaterMark.js.map